<template>
	<section>
		<form @submit.prevent="null">
			<client-logo v-if="!isiFrame" />
			<tab-header v-if="!isiFrame" />
			<div class="page cart">
				<!-- <div id="secure-checkout" class="text_size-large text_color-green">
          <i class="material-icons mr-1">lock</i>
          <span>Secure Checkout</span>
        </div> -->
				<!-- <div class="container large"> -->
				<div id="cart-container">
					<div id="secure-checkout" class="text_size-large text_color-green">
						<i class="material-icons mr-1">lock</i>
						<span>Secure Checkout</span>
					</div>
					<!-- <pre>DigitalWalletKey: {{ DigitalWalletKey }}</pre> -->
					<!-- <section id="card_items" class="left"> -->
					<section id="customer_items">
						<!-- <pre>customerValidPreSubmit: {{ customerValidPreSubmit }}</pre> -->
						<!-- <pre>customerValidAfterSubmit: {{ customerValidAfterSubmit }}</pre> -->
						<!-- <pre>entireFormValid: {{ entireFormValid }}</pre> -->
						<!-- <pre>emailValid: {{emailValid}}</pre> -->

						<contact-info
							v-if="!getOrderLoading"
							:customer="customer"
							:customerValid="customerValidAfterSubmit"
							:formSubmitted="formSubmitted"
							:hasRequirements="hasRequirements"
							:emailValid="emailValid"
							:emailHasFailed="emailHasFailed"
							:requireEmailOptIn="requireEmailOptIn"
							@updateEmailValid="updateEmailValid"
							@updateEmailHasFailed="emailHasFailed = true"
							:paymentIsOpen="paymentIsOpen"
							@shouldClosePayment="paymentIsOpen = false"
							@shouldOpenPayment="paymentIsOpen = true"
						/>

						<!-- <pre>cardErrors: {{ cardErrors }}</pre> -->
						<!-- <pre>completeOrderData: {{ completeOrderData }}</pre> -->

						<contact-info-box
							v-show="!getOrderLoading"
							id="payment_card"
							:badge="paymentBadgeCount"
							title="Payment Information"
							:closed="!paymentIsOpen"
							@opened="paymentIsOpen = true"
							:active="entireCustomerValid"
						>
							<template v-slot:active>
								<div class="active-wrapper">
									<!-- <digital-wallet
										v-show="order.Balance > 0"
										:entireCustomerValid="entireCustomerValid"
										:client="client"
									/>
									<credit-card
										v-show="order.Balance != 0"
										:paymentForm="paymentForm"
										:preSubmittedCardValidation="preSubmittedCardValidation"
										:cardBrand="cardBrand"
										:formSubmitted="formSubmitted"
										:cardErrors="cardErrors"
									/> -->

									<!-- SQUARE_V2 -->
									<square-web-payments
										v-show="client && order"
										:order="order"
										:client="client"
										@submitPayment="validateForm($event)"
									></square-web-payments>

									<p
										v-if="(!entireFormValid || emailHasFailed) && formSubmitted"
										class="error"
									>
										Fill out all fields and try again.
									</p>
									<!-- <a
										href
										@click.prevent="validateForm"
										class="button blue text-center wide-cart-btn"
										:class="{ button_loading: completeOrderLoading }"
										>Complete order</a
									> -->
									<p style="width:100%; text-align: center">
										<small class="text-gray text_size-medium-small"
											>By completing the order you agree to Singenuity's
											<a href="https://singenuity.com/privacy/" target="_blank"
												>Privacy&nbsp;Policy</a
											>
											and
											<a href="https://singenuity.com/privacy/" target="_blank"
												>Terms&nbsp;of&nbsp;Service</a
											>.
										</small>
									</p>
								</div>
							</template>
						</contact-info-box>
					</section>
					<section id="cart_items" v-if="!getOrderLoading">
						<div id="order_headline">Order Summary</div>
						<div class="order-rows">
							<cart-row-individual
								v-for="(product, i) in orderIndividual"
								:product="product"
								:key="
									'cart-row-ind-activity-' + product.OrderEntityKey + '-' + i
								"
							/>
							<cart-row-package
								v-for="(product, i) in orderPackages"
								:product="product"
								:key="
									'cart-row-package-activity-' +
										product.OrderPackageKey +
										'-' +
										i
								"
							/>
							<cart-row-gift-card
								v-for="(product, i) in orderGiftcards"
								:product="product"
								:key="
									'cart-row-giftcard-product-' +
										product.OrderMerchandiseKey +
										'-' +
										i
								"
							/>
						</div>

						<div class="cart-divider" />

						<div id="discount-accordion" v-if="promoGiftCardString">
							<details>
								<summary>{{ promoGiftCardString }}</summary>
								<div class="details-content">
									<promos v-show="!client.DisablePromoCodes" />
									<giftcard-payment v-show="client.EnableGiftCards" />
								</div>
							</details>
						</div>

						<div
							class="cart-divider"
							v-show="
								order.EnableOnlineDeposits && !order.EnableBalanceCheckout
							"
						/>

						<deposit
							v-show="
								order.EnableOnlineDeposits && !order.EnableBalanceCheckout
							"
						/>

						<div class="cart-divider" v-show="order.EnableOnlineDeposits" />

						<!-- <pre>
              Online Deposits = {{ order.EnableOnlineDeposits }}
            </pre> -->

						<cart-totals />

						<!-- <button
              class="button blue mb-0 text-center block"
              style="width:100%"
              id="checkout_button"
              @click.prevent="scrollToCheckout"
            >
              Checkout
            </button> -->
						<div class="cart-links text_size-large">
							<span class="link  cart-link" @click.prevent="keepShoppingClick"
								>Keep shopping</span
							>
							<span
								@click.prevent="confirmStartOverModal.show = true"
								class="link cart-link"
							>
								Start over
							</span>
						</div>
						<div id="power-footer">
							<a href="https://singenuity.com/" target="_blank">
								<img src="@/assets/logo.png" height="32" />
							</a>
							<a href="https://singenuity.com/" target="_blank">
								Powered by Singenuity
							</a>
						</div>
					</section>
					<div id="power-footer-mobile">
						<a href="https://singenuity.com/" target="_blank">
							<img src="@/assets/logo.png" height="32" />
						</a>
						<a href="https://singenuity.com/" target="_blank">
							Powered by Singenuity
						</a>
					</div>
				</div>
			</div>
			<modal v-if="processingPaymentModal.show" :modal="processingPaymentModal">
				<template>
					<div class="text-center text_style-bold text_size-x-large pt-2">
						Saving your order...
					</div>
					<div class="pt-3 pb-2">
						<loader />
					</div>
					<div class="text-center pt-1 pb-2">
						This may take a minute.<br />Please don't close or refresh.
					</div>
				</template>
			</modal>

			<modal v-show="paymentErrorModal.show" :modal="paymentErrorModal">
				<template>
					<p class="text-center pt-2 pb-2">
						{{ paymentErrorModal.message }}
					</p>
				</template>
				<template v-slot:footer>
					<button
						href
						@click.prevent="paymentErrorModal.show = false"
						class="button red ml-1"
					>
						OK
					</button>
				</template>
			</modal>

			<modal v-if="removeFromCartModal.show" :modal="removeFromCartModal">
				<p class="text-center pt-3 pb-3">
					Are you sure you want to remove this item from your cart?
				</p>
				<template v-slot:footer>
					<button
						href
						:disabled="removeFromCartModal.loading"
						@click.prevent="closeRemoveFromCartModal"
						class="button ml-0 focus"
					>
						Nevermind
					</button>
					<button
						href
						:disabled="removeFromCartModal.loading"
						@click.prevent="removeFromCart"
						:class="{ button_loading: removeFromCartModal.loading }"
						class="button red ml-1"
					>
						Remove
					</button>
				</template>
			</modal>

			<modal :modal="confirmStartOverModal" v-if="confirmStartOverModal.show">
				<!--        <loader v-if="confirmStartOverModal.loading" />-->
				<p class="text-center pt-3 pb-3">
					Are you sure you want to remove all items from your cart and start
					over?
				</p>

				<template v-slot:footer>
					<button
						href
						:disabled="confirmStartOverModal.loading"
						@click.prevent="confirmStartOverModal.show = false"
						class="button ml-0 focus"
					>
						Nevermind
					</button>
					<button
						href
						:disabled="confirmStartOverModal.loading"
						@click.prevent="startOverGo"
						:class="{ button_loading: confirmStartOverModal.loading }"
						class="button red ml-1"
					>
						Start over
					</button>
				</template>
			</modal>
		</form>

		<loader class="fullpage" v-if="getOrderLoading" />

		<post-complete-order-modals />
	</section>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';

	import TabHeader from '../components/TabHeader.vue';
	import Modal from '../components/Modal.vue';
	import ClientLogo from '../components/ClientLogo.vue';
	//import CartBar from "../components/CartBar.vue";
	import CartTotals from '../components/CartTotals.vue';
	import CartRowIndividual from '../components/CartRowIndividual.vue';
	import CartRowPackage from '../components/CartRowPackage.vue';
	import CartRowGiftCard from '../components/CartRowGiftCard.vue';
	import Promos from '../components/Promos.vue';
	import GiftcardPayment from '../components/GiftcardPayment.vue';
	import ContactInfo from '../components/ContactInfo.vue';
	// import CreditCard from '../components/CreditCard.vue';
	// import DigitalWallet from '../components/DigitalWallet.vue';
	import Loader from '../components/Loader.vue';
	import PostCompleteOrderModals from '../components/PostCompleteOrderModals.vue';
	import ContactInfoBox from '@/components/ContactInfoBox.vue';
	import Deposit from '@/components/Deposit.vue';
	import SquareWebPayments from '@/components/SquareWebPayments.vue';

	import analyticsMixin from '../mixins/analyticsMixin.js';
	import customFieldHelpers from '@/mixins/customFieldHelpers';

	// import router from "../router";

	export default {
		name: 'Cart',
		components: {
			TabHeader,
			Modal,
			CartRowIndividual,
			CartRowPackage,
			CartRowGiftCard,
			Promos,
			GiftcardPayment,
			ContactInfo,
			ClientLogo,
			Loader,
			// CreditCard,
			CartTotals,
			// DigitalWallet,
			PostCompleteOrderModals,
			Deposit,
			ContactInfoBox,
			SquareWebPayments,
		},
		data() {
			return {
				//notes: "",
				iframe: false,
				completeOrderLoading: false,
				emailHasFailed: false,
				formSubmitted: false,
				paymentForm: null,
				digitalWalletForm: null,
				preSubmittedCardValidation: {},
				cardBrand: null,
				DigitalWalletKey: null,
				cardErrors: null,
				modalCardErrors: {
					show: false,
				},
				emailValid: true,
				cardData: false,
				pmtToken: null,
				nonce: false,
				confirmStartOverModal: {
					show: false,
					hideHeader: true,
					id: 'confirmStartOverModal',
					loading: false,
				},
				paymentIsOpen: false,
				CData: null, // encrypted card data string for payment failure
				processingPaymentModal: {
					id: 'processingPaymentModal',
					show: false,
					hideHeader: true,
				},
				paymentErrorModal: {
					id: 'paymentErrorModal',
					show: false,
					hideHeader: false,
					heading: '',
					message: '',
				},
			};
		},
		mixins: [analyticsMixin, customFieldHelpers],
		watch: {
			order: {
				handler: function() {
					// console.log("order update", this.order);
				},
			},
			getOrderLoading: {
				handler: function(newVal) {
					// if it's done ajaxing the Order Object
					// see if I actuall have product in the cart
					if (!newVal && !this.order.CartCount) {
						console.log('Navigating to root');
						this.$router.push('/' + this.$route.params.client);
					}
					//
					else {
						this.toggleCartLinkActive(true);
					}
				},
				immediate: true,
			},

			paymentIsOpen(val) {
				if (val) {
					// this.launch_square_up();
				} else if (this.paymentForm) {
					this.paymentForm.destroy();
					this.digitalWalletForm.destroy();
				}
			},
			// "client.PaymentPublicApiKey": {
			//   handler: function() {
			//     if (typeof this.client.PaymentPublicApiKey == "string") {
			//       setTimeout(() => {
			//         if (document.getElementById("sq-card")) {
			//         } else {
			//           setTimeout(()=> {
			//             if (document.getElementById("sq-card")) {
			//             this.launch_square_up();
			//             } else {
			//               alert("Unable to load square form")
			//           }
			//             }, 1000)
			//           }
			//       }, 500);

			//     }
			//   },
			//   immediate: true
			// }
		},
		computed: {
			...mapState([
				'client',
				'order',
				'discount',
				'removeFromCartModal',
				'productToRemove',
				'getOrderLoading',
				'overlappedActivities',
			]),
			//If we have no defined 'heard about us' return true
			disableHeardAboutUs() {
				return this.client.HeardAboutUs.length == 0;
			},
			paymentBadgeCount() {
				return this.customFieldActivities.length + 3;
			},
			isiFrame: function() {
				try {
					return window.self !== window.top;
				} catch (e) {
					return true;
				}
			},
			requireEmailOptIn() {
				return this.client.RequireEmailOptIn;
			},
			promoGiftCardString() {
				if (!this.client.DisablePromoCodes && this.client.EnableGiftCards)
					return 'Apply gift card or promo code';
				else if (!this.client.DisablePromoCodes) return 'Apply promo code';
				else if (this.client.EnableGiftCards) return 'Apply gift card';
				else return null;
			},
			sojernProductsSnapshot() {
				if (this.order && this.order.Packages) {
					let participants = 0;

					this.order.Packages.forEach((ele) => {
						participants += ele.Participants;
					});
					this.order.Individual.forEach((ele) => {
						participants += ele.Participants;
					});

					return [
						{
							departureDate: this.order.StartDate,
							returnDate: this.order.EndDate,
							name: this.order.ActivityNames,
							totalParticipants: participants,
							//orderEntityKey: activity.OrderEntityKey
						},
					];
				}
				return [];
			},

			digitalWalletLineItems: function() {
				let lineItems = [];

				if (this.order && this.order.Individual) {
					this.order.Individual.forEach((element) => {
						lineItems.push({
							label: element.Activities[0].Name,
							amount: String(element.Activities[0].SubTotal),
							pending: false,
						});
					});

					this.order.Packages.forEach((element) => {
						lineItems.push({
							label: element.Name,
							amount: String(element.SubTotal),
							pending: false,
						});
					});

					lineItems.push({
						label: 'Taxes and Fees',
						amount: String(this.order.TaxTotal),
						pending: false,
					});
				} // if

				return lineItems;
			},

			completeOrderData() {
				let data = {};
				if (this.cardData || this.order.Balance <= 0) {
					try {
						data.DigitalWalletKey = this.cardData.digitalWallet
							? this.cardData.digitalWallet
							: null;
					} catch {
						console.error('Could not set digital wallet key.');
					}

					try {
						data.CardType = this.cardData.details
							? this.cardData.details.card.brand
							: null;
					} catch {
						console.error('Could not set card brand.');
					}

					try {
						data.CardNumber = this.cardData.details
							? this.cardData.details.card.last4
							: null;
					} catch {
						console.error('Could not set last 4.');
					}

					try {
						data.ExpDate = this.cardData.details
							? `${this.cardData.details.card.expMonth}/${this.cardData.details.card.expYear}`
							: null;
					} catch {
						console.error('Could not set card expiration.');
					}

					try {
						(data.NameOnCard = this.cardData.billingName),
							(data.CardCountry = this.cardData.billingCountry);
					} catch {
						console.error('Could not set billing name or country.');
					}

					try {
						data.Zip = this.cardData.details
							? this.cardData.details.billing.postalCode
							: this.customer.zip;
					} catch {
						console.error('Could not set card zip.');
					}

					try {
						data.Token = this.cardData.token ? this.cardData.token : '';
					} catch {
						console.error('Could not set square token.');
					}

					data.PromoCode = this.discount.value;
					data.Customer = this.customer;
					data.Note = this.customer.notes;
					data.ClientLocationKey = this.$route.params.client;
					data.OrderKey = this.order.OrderKey;
					data.Agreed = this.customer.Agreed;
					data.BypassEmailValidation = this.emailHasFailed;
					data.Order = this.order;

					try {
						data.CData = this.CData ? this.CData : null;
					} catch {
						console.error('Could not set cdata.');
					}
					// data.CardNumber = this.cardData.last_4 ? this.cardData.last_4 : null;
					// data.CardType = this.cardData.card_brand
					// ? this.cardData.card_brand
					// : null;
					// data.ExpDate = this.cardData.exp_month
					// 	? this.cardData.exp_month + '/' + this.cardData.exp_year
					// 	: null;
					// data.Token = this.nonce;
					// data.Zip = this.cardData.billing_postal_code
					// 	? this.cardData.billing_postal_code
					// 	: this.customer.Zip;
					// data.DigitalWalletKey = this.DigitalWalletKey
					// 	? this.DigitalWalletKey
					// 	: null;
				}

				return data;
			},

			customerValidPreSubmit() {
				let agreed = true;
				if (this.orderIndividual.length || this.orderPackages.length) {
					agreed = !!this.customer.Agreed;
				}
				if (!this.hasRequirements) {
					agreed = true;
				}

				return {
					email: this.customer.Email != '' && this.emailValid == true,
					firstName: this.customer.FirstName != '',
					lastName: this.customer.LastName != '',
					phoneCountryKey: this.customer.PhoneCountryKey != '',
					phoneAreaCode: this.customer.PhoneAreaCode != '',
					phoneSubscriberNumber: this.customer.PhoneSubscriberNumber != '',
					clientLocationHeardAboutUsKey:
						this.customer.ClientLocationHeardAboutUsKey != null ||
						this.disableHeardAboutUs,
					agreed: agreed,

					heardAboutUsOther:
						(this.customer.ClientLocationHeardAboutUsKey == 0 &&
							this.customer.HeardAboutUsOther &&
							this.customer.HeardAboutUsOther != '') ||
						this.customer.ClientLocationHeardAboutUsKey != 0,
				};
			},

			entireCustomerValid() {
				if (!this.allFieldsAnswered) {
					return false;
				}
				// customer data errors
				// eslint-disable-next-line no-unused-vars
				for (let [key, value] of Object.entries(this.customerValidPreSubmit)) {
					//console.log(`${key}: ${value}`);
					if (value == false) {
						return false;
					}
				}
				return true;
			},

			customerValidAfterSubmit() {
				let o = {};

				let emailValid = /(.+)@(.+){2,}\.(.+){2,}/.test(this.customer.Email);

				let agreed =
					this.orderIndividual.length || this.orderPackages.length
						? !!this.customer.Agreed
						: true;

				if (!this.hasRequirements) {
					agreed = true;
				}
				if (this.formSubmitted) {
					o = {
						email: emailValid,
						firstName: this.customer.FirstName != '',
						lastName: this.customer.LastName != '',
						phoneCountryKey: this.customer.PhoneCountryKey != '',
						phoneAreaCode: this.customer.PhoneAreaCode != '',
						phoneSubscriberNumber: this.customer.PhoneSubscriberNumber != '',
						clientLocationHeardAboutUsKey:
							this.customer.ClientLocationHeardAboutUsKey != null ||
							this.disableHeardAboutUs,
						agreed: agreed,
						heardAboutUsOther:
							(this.customer.ClientLocationHeardAboutUsKey == 0 &&
								this.customer.HeardAboutUsOther &&
								this.customer.HeardAboutUsOther != '') ||
							this.customer.ClientLocationHeardAboutUsKey != 0,
					};
				} else {
					// if the form has not been submitted, let's pretend that every is valid
					o = {
						email: true,
						firstName: true,
						lastName: true,
						phoneCountryKey: true,
						phoneAreaCode: true,
						phoneSubscriberNumber: true,
						clientLocationHeardAboutUsKey: true,
						agreed: true,
						heardAboutUsOther: true,
					};
				}

				return o;
			},

			orderIndividual() {
				return this.order.Individual || false;
			},
			orderPackages() {
				return this.order.Packages || false;
			},
			orderGiftcards() {
				return this.order.GiftCards.filter((item) => !item.IsDeleted) || false;
			},
			customer: function() {
				return this.$store.state.order.Customer
					? this.$store.state.order.Customer
					: false;
			},
			hasRequirements() {
				if (
					this.order &&
					this.order.Requirements &&
					this.order.Requirements.length
				) {
					return this.order.Requirements;
				}
				return false;
			},
			checkout() {
				return this.$route.params.checkout;
			},

			entireFormValid() {
				if (!this.entireCustomerValid) {
					return false;
				}
				// customer data errors
				// eslint-disable-next-line no-unused-vars
				for (let [key, value] of Object.entries(
					this.customerValidAfterSubmit
				)) {
					//console.log(`${key}: ${value}`);
					if (value == false) {
						return false;
					}
				}
				if (this.order.Balance != 0) {
					// eslint-disable-next-line no-unused-vars
					for (let [key, value] of Object.entries(
						this.preSubmittedCardValidation
					)) {
						if (!value) {
							return false;
						}
					}
				}

				return true;
			},
		},

		methods: {
			...mapActions([
				'closeRemoveFromCartModal',
				'removeFromCart',
				'startOver',
				'completeOrder',
			]),
			keepShoppingClick() {
				this.$router.push('/' + this.$route.params.client);
			},
			startOverGo() {
				this.confirmStartOverModal.loading = true;
				this.startOver({
					success: () => {
						this.confirmStartOverModal.show = false;
						this.confirmStartOverModal.loading = false;
						setTimeout(() => {
							this.$router.push({ path: '/' + this.$route.params.client });
						}, 1);
					},
				});
			},

			myCompleteOrder() {
				this.completeOrderLoading = true;
				this.processingPaymentModal.show = true;
				console.log('[orderData]', this.completeOrderData);
				this.completeOrder(this.completeOrderData).then(
					(json) => {
						//this.addToCartLoading = false;
						//if (json.Order && json.Order.OrderKey) {
						//  this.resetGiftcard();
						//}

						// if no order comes back, exception thrown, close modal
						if (!json.Order) {
							this.processingPaymentModal.show = false;
						}

						if (json.IsInvalidEmail) {
							this.emailHasFailed = true;
						} else if (json.ExceptionMessage) {
							console.error(json.ExceptionMessage);
						} else if (json.DupTransaction && json.DupTransactionMessage) {
							this.paymentErrorModal.heading = 'Duplicate transaction';
							this.paymentErrorModal.message = json.DupTransactionMessage;

							this.processingPaymentModal.show = false;
							this.paymentErrorModal.show = true;
						} else if (json.ModelErrors) {
							var str = '';
							for (var i in json.ModelErrors) {
								for (var j in json.ModelErrors[i].Value) {
									str += json.ModelErrors[i].Value[j] + '\n';
								}
							}
							this.paymentErrorModal.heading = 'Something went wrong...';
							this.paymentErrorModal.message = str;

							this.processingPaymentModal.show = false;
							this.paymentErrorModal.show = true;
						} else if (json.TakenTimes) {
							console.warn(json.TakenTimes);
							//             alert("TODO: TakenTimes");
						} else if (json.CardDeclined && json.CardDeclinedMessage) {
							this.CData = json.CData;
							localStorage.setItem('CData', JSON.stringify(this.CData));

							this.paymentErrorModal.heading = 'Card Declined';
							this.paymentErrorModal.message = json.CardDeclinedMessage;

							this.processingPaymentModal.show = false;
							this.paymentErrorModal.show = true;
						} else {
							try {
								this.paymentForm.destroy();
								this.digitalWalletForm.destroy();
							} catch (err) {
								//console.warn("No this.paymentForm.destroy();");
							}

							// OnCompleteOrder is defined by the user and is set by the master template
							if (typeof window.OnCompleteOrder != 'undefined') {
								//console.log("window.OnCompleteOrder()");
								window.OnCompleteOrder(
									this.$store.getters.simpleOrder,
									this.customer
								);
							}

							// /completeorder returns the Order Object
							if (json.Order && json.Order.OrderKey) {
								// Googe Analytics
								this.sendGoogleAnalytics();

								// Google Adwords
								this.sendGoogleAdwords();

								// Facebook Pixel
								this.sendFaceBookPixel();

								// Sojern
								this.sendSojernConversion();
								// Facebook Pixel
								this.sendFaceBookPixel();

								// Bind Ads
								this.sendBingEvent();

								// Sojern
								this.sendSojernConversion();

								localStorage.removeItem['CData']; // remove card error cache
								this.$store.commit('clearDiscount'); // remove any discount

								//! 07/19/2021 - commented out timeout fuction bc store mutations are synchronous
								//! why are we waiting 500ms for the store to update??
								// setTimeout(() => {
								this.$store.commit('updateOrder', json.Order);
								this.$router.push({
									path: '/' + json.Order.ClientLocationKey + '/complete',
								});

								this.processingPaymentModal.show = false;
								// }, 500);
							}
						}

						this.completeOrderLoading = false;
					},
					(err) => {
						// alert('TODO: error completeOrder');
						console.error('completeOrder error', err);
						this.processingPaymentModal.show = false;
					}
				);
			},

			...mapMutations(['toggleCartLinkActive']),

			updateEmailValid(payload) {
				this.emailValid = payload;
				if (payload) {
					this.emailHasFailed = false;
				}
			},

			completePayment(nonce, cardData) {
				this.$set(this, 'nonce', nonce);
				this.$set(this, 'cardData', cardData);
				// to do
				//alert("call completeOrder");

				//this.completeOrder(this.completeOrderData);
				//console.log("completeOrderData:", this.completeOrderData);

				this.myCompleteOrder();
			},

			scrollToError() {
				// to do
			},

			validateForm(token) {
				// to do validation
				if (this.completeOrderLoading) {
					return;
				}
				this.formSubmitted = true;

				if (this.entireCustomerValid) {
					this.$set(this, 'cardData', token ? token : {});
					this.myCompleteOrder();
				}

				// if (this.entireFormValid) {
				// 	if (this.order.Balance > 0) {
				// 		this.$set(this, 'cardData', token);
				// 		this.myCompleteOrder();
				// 		// this.paymentForm.requestCardNonce();
				// 	}
				// 	//
				// 	else {
				// 		// alert("Zero balance");
				// 		this.myCompleteOrder();
				// 	}
				// }
			},

			validateFormZeroBalance() {
				this.formSubmitted = true;
			},

			scrollToCheckout() {
				console.log('STC');
				//.scrollIntoView(false);
				if (document.querySelector('#contact_info')) {
					//alert("scrollToCheckout #contact_info");
					// document
					//   .querySelector("#contact_info")
					//   .scrollIntoView({ behavior: "smooth", block: "end" });
					window.$('html, body').animate(
						{
							scrollTop: window.$('#contact_info').offset().top - 50,
						},
						500
					);
				}

				if (document.querySelector('#email')) {
					setTimeout(() => {
						document.querySelector('#email').focus();
					}, 550);
					//
				}
			},

			launch_square_up: function() {
				var tis = this;
				let applicationId = this.client.PaymentPublicApiKey;
				let locationId = this.client.SquareLocationId;
				let client = this.client;
				// console.log("Attempting to build square forms", this.client.PaymentPublicApiKey, this.client.SquareLocationId )
				// eslint-disable-next-line no-undef
				// console.log($("#sq-card"))
				// eslint-disable-next-line no-undef
				this.digitalWalletForm = new SqPaymentForm({
					// Initialize the payment form elements
					applicationId: applicationId,
					locationId: locationId,
					inputClass: 'sq-input',
					autoBuild: false,
					// Customize the CSS for SqPaymentForm iframe elements
					inputStyles: [
						{
							fontSize: '18px',
							fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', //"Helvetica", // -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif
							padding: '14px 0',
							placeholderColor: '#67696f',
						},
					],
					applePay: { elementId: 'sq-apple-pay' },
					googlePay: { elementId: 'sq-google-pay' },

					callbacks: {
						methodsSupported: function(methods, unsupportedReason) {
							let walletBox = document.getElementById('sq-walletbox');
							let applePayBtn = document.getElementById('sq-apple-pay');
							let googlePayBtn = document.getElementById('sq-google-pay');

							// Only show the button if Apple Pay for Web is enabled
							if (methods.applePay && !client.DisableApplePayOnline) {
								if ((methods.applePay === true, walletBox && applePayBtn)) {
									walletBox.style.display = 'block';
									applePayBtn.style.display = 'block';
								} else {
									applePayBtn.style.display = 'none';
									console.warn('applePay', unsupportedReason);
								}
							}
							// Only show the button if Google Pay is enabled
							if (methods.googlePay && !client.DisableGooglePayOnline) {
								if ((methods.googlePay === true, walletBox && googlePayBtn)) {
									walletBox.style.display = 'block';
									googlePayBtn.style.display = 'inline-block';
								} else {
									googlePayBtn.style.display = 'none';
									console.warn('googlePay', unsupportedReason);
								}
							}
						},

						// * callback function: createPaymentRequest
						// * Triggered when: a digital wallet payment button is clicked.

						createPaymentRequest: () => {
							// Check for form errors before advancing
							//alert("createPaymentRequest");
							// remove me!!!!

							//this.validateRequirements();
							//console.log('foo', foo);

							var valid = this.customerValidAfterSubmit;

							//console.log("createPaymentRequest() valid " + valid);

							if (!valid) {
								this.scrollToError();
								return false;
							}
							//
							else {
								//alert("is valid " + valid);
								var paymentRequestJson = {
									requestShippingAddress: false,
									//this.digital_wallet_type == "APPLE_PAY" ? false : true,
									requestBillingInfo: false,
									currencyCode: this.client.SquareCurrencyCode, //"USD",
									countryCode: this.client.CountryCode.toUpperCase(), // "US",
									total: {
										label: this.client.Name, //"MERCHANT NAME",
										amount: String(this.order.Total), //"100",
										pending: false,
									},
									lineItems: this.digitalWalletLineItems,
								};

								//console.log("paymentRequestJson");
								//console.log(paymentRequestJson);

								clearTimeout(this.myInt);

								this.myInt = setInterval(() => {
									//console.log("try to close gpay-graypane " + this.myInt);

									// eslint-disable-next-line no-undef
									if ($('gpay-graypane').length) {
										// eslint-disable-next-line no-undef
										$('gpay-graypane').hide();
										clearTimeout(this.myInt);
									}
								}, 4000);

								return paymentRequestJson;
							}
						},
						shippingContactChanged: function(shippingContact, done) {
							var valid = true;
							var shippingErrors = {};

							if (!shippingContact.postalCode) {
								shippingErrors.postalCode = 'postal code is required';
								valid = false;
							}
							if (!shippingContact.addressLines) {
								shippingErrors.addressLines = 'address lines are required';
								valid = false;
							}

							if (!valid) {
								done({ shippingContactErrors: shippingErrors });
								return;
							}
							done();
						},

						// * callback function: cardNonceResponseReceived
						// * Triggered when: SqPaymentForm completes a card nonce request

						cardNonceResponseReceived: (
							errors,
							nonce,
							cardData
							// billingContact,
							// shippingContact
						) => {
							console.error(
								'+++++++++++++++++++++++++++ cardData.digital_wallet_type+++++++++++++++++++++++++++  ' +
									cardData.digital_wallet_type
							);

							if (cardData) {
								if (cardData.digital_wallet_type == 'APPLE_PAY') {
									this.DigitalWalletKey = 1;
								}
								//
								else if (cardData.digital_wallet_type == 'MASTERPASS') {
									this.DigitalWalletKey = 2;
								}
								//
								else if (cardData.digital_wallet_type == 'GOOGLE_PAY') {
									this.DigitalWalletKey = 3;
								}
							}

							// do not send to server if there are any errors
							if (!errors) {
								console.warn('No Card errors!');

								this.completePayment(nonce, cardData);
							} else {
								console.error(
									'cardNonceResponseReceived Card errors!!!!!!!!!!!!!!!!!!!!!!!!'
								);
								console.error('errors', errors);
								//this.disableButton = false;
								this.cardErrors = errors;
								this.modalCardErrors.show = true;

								this.scrollToError();
							}

							//document.location = 'https://book.singenuity.com/payonarrival/' + encodeURIComponent(JSON.stringify(model));
						},

						// * callback function: unsupportedBrowserDetected
						// * Triggered when: the page loads and an unsupported browser is detected

						unsupportedBrowserDetected: function() {
							alert('Unsupported Browser Detected');
							// PROVIDE FEEDBACK TO SITE VISITORS
						},

						// * callback function: inputEventReceived
						// * Triggered when: visitors interact with SqPaymentForm iframe elements.

						inputEventReceived: (inputEvent) => {
							//console.log("inputEventReceived()");
							//console.log(inputEvent);

							var element = inputEvent.elementId.replace(/-/g, '');
							this.$set(
								this.preSubmittedCardValidation,
								element,
								inputEvent.currentState.isCompletelyValid
							); //this.preSubmittedCardValidation

							//console.log(inputEvent.elementId);
							//console.log(inputEvent.currentState.isCompletelyValid);

							//$('#wrap-'+inputEvent.elementId).find('p.error').toggleClass('show', inputEvent.currentState.hasErrorClass);
							//$('#'+inputEvent.elementId).prev('p').toggleClass('hasError', inputEvent.currentState.hasErrorClass);

							switch (inputEvent.eventType) {
								case 'focusClassAdded':
									//console.log('focusClassAdded');
									break;
								case 'focusClassRemoved':
									//console.log('focusClassRemoved');
									break;
								case 'errorClassAdded':
									console.warn('errorClassAdded');
									//console.log(inputEvent);
									// eslint-disable-next-line no-undef
									$('#wrap-' + inputEvent.elementId).removeClass(
										'errorClassRemoved'
									);

									break;
								case 'errorClassRemoved':
									//console.log('errorClassRemoved');
									//console.log(inputEvent);
									// eslint-disable-next-line no-undef
									$('#wrap-' + inputEvent.elementId).addClass(
										'errorClassRemoved'
									);
									break;
								case 'cardBrandChanged':
									//console.log('cardBrandChanged');
									//console.log(inputEvent);

									//$('#wrap-'+inputEvent.elementId).find('#card-icon').attr('class', inputEvent.cardBrand);
									tis.cardBrand = inputEvent.cardBrand;

									break;
								case 'postalCodeChanged':
									//console.log('postalCodeChanged');
									break;
							}

							// see if there are any errors in the dom
							// eslint-disable-next-line no-undef
							tis.cardErrorsInDOM = $('.sq-input--error').length;
						},

						// * callback function: paymentFormLoaded
						// * Triggered when: SqPaymentForm is fully loaded

						paymentFormLoaded: function() {
							// HANDLE AS DESIRED
							//alert('paymentFormLoad');
							// eslint-disable-next-line no-undef
							$('#sq-walletbox').addClass('loaded');

							//console.log('paymentFormLoaded    !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
						},
					},
				});
				// console.log("after wallet")
				// eslint-disable-next-line no-undef
				this.paymentForm = new SqPaymentForm({
					// Initialize the payment form elements
					applicationId: applicationId,
					locationId: locationId,
					inputClass: 'sq-input',
					autoBuild: false,
					// Customize the CSS for SqPaymentForm iframe elements
					inputStyles: [
						{
							fontSize: '18px',
							fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', //"Helvetica", // -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif
							padding: '14px 0',
							placeholderColor: '#67696f',
						},
					],
					// Initialize the credit card placeholders
					card: { elementId: 'sq-card' },

					// SqPaymentForm callback functions
					callbacks: {
						// methodsSupported: function(methods, unsupportedReason) { console.log(methods,unsupportedReason) },
						createPaymentRequest: () => {
							var valid = this.customerValidAfterSubmit;
							if (!valid) {
								this.scrollToError();
								return false;
							}
							//
							else {
								//alert("is valid " + valid);
								var paymentRequestJson = {
									requestShippingAddress: false,
									//this.digital_wallet_type == "APPLE_PAY" ? false : true,
									requestBillingInfo: false,
									currencyCode: this.client.SquareCurrencyCode, //"USD",
									countryCode: this.client.CountryCode.toUpperCase(), // "US",
									total: {
										label: this.client.Name, //"MERCHANT NAME",
										amount: String(this.order.Total), //"100",
										pending: false,
									},
									lineItems: this.digitalWalletLineItems,
								};
								clearTimeout(this.myInt);

								this.myInt = setInterval(() => {
									//console.log("try to close gpay-graypane " + this.myInt);

									// eslint-disable-next-line no-undef
									if ($('gpay-graypane').length) {
										// eslint-disable-next-line no-undef
										$('gpay-graypane').hide();
										clearTimeout(this.myInt);
									}
								}, 4000);

								return paymentRequestJson;
							}
						},
						shippingContactChanged: function(shippingContact, done) {
							var valid = true;
							var shippingErrors = {};

							if (!shippingContact.postalCode) {
								shippingErrors.postalCode = 'postal code is required';
								valid = false;
							}
							if (!shippingContact.addressLines) {
								shippingErrors.addressLines = 'address lines are required';
								valid = false;
							}

							if (!valid) {
								done({ shippingContactErrors: shippingErrors });
								return;
							}
							done();
						},

						// * callback function: cardNonceResponseReceived
						// * Triggered when: SqPaymentForm completes a card nonce request

						cardNonceResponseReceived: (
							errors,
							nonce,
							cardData
							// billingContact,
							// shippingContact
						) => {
							//console.error("cardNonceResponseReceived errors");
							console.error(
								'+++++++++++++++++++++++++++ cardData.digital_wallet_type+++++++++++++++++++++++++++  ' +
									cardData.digital_wallet_type
							);

							if (cardData) {
								if (cardData.digital_wallet_type == 'APPLE_PAY') {
									this.DigitalWalletKey = 1;
								}
								//
								else if (cardData.digital_wallet_type == 'MASTERPASS') {
									this.DigitalWalletKey = 2;
								}
								//
								else if (cardData.digital_wallet_type == 'GOOGLE_PAY') {
									this.DigitalWalletKey = 3;
								}
							}

							// do not send to server if there are any errors
							if (!errors) {
								console.warn('No Card errors!');

								this.completePayment(nonce, cardData);
							} else {
								console.error(
									'cardNonceResponseReceived Card errors!!!!!!!!!!!!!!!!!!!!!!!!'
								);
								console.error('errors', errors);
								//this.disableButton = false;
								this.cardErrors = errors;
								this.modalCardErrors.show = true;

								this.scrollToError();
							}

							//document.location = 'https://book.singenuity.com/payonarrival/' + encodeURIComponent(JSON.stringify(model));
						},

						// * callback function: unsupportedBrowserDetected
						// * Triggered when: the page loads and an unsupported browser is detected

						unsupportedBrowserDetected: function() {
							alert('Unsupported Browser Detected');
							// PROVIDE FEEDBACK TO SITE VISITORS
						},

						// * callback function: inputEventReceived
						// * Triggered when: visitors interact with SqPaymentForm iframe elements.

						inputEventReceived: (inputEvent) => {
							var element = inputEvent.elementId.replace(/-/g, '');

							this.$set(
								this.preSubmittedCardValidation,
								element,
								inputEvent.currentState.isCompletelyValid
							);
							switch (inputEvent.eventType) {
								case 'focusClassAdded':
									break;
								case 'focusClassRemoved':
									break;
								case 'errorClassAdded':
									console.warn('errorClassAdded');
									// eslint-disable-next-line no-undef
									$('#wrap-' + inputEvent.elementId).removeClass(
										'errorClassRemoved'
									);

									break;
								case 'errorClassRemoved':
									// eslint-disable-next-line no-undef
									$('#wrap-' + inputEvent.elementId).addClass(
										'errorClassRemoved'
									);
									break;
								case 'cardBrandChanged':
									//$('#wrap-'+inputEvent.elementId).find('#card-icon').attr('class', inputEvent.cardBrand);
									tis.cardBrand = inputEvent.cardBrand;

									break;
								case 'postalCodeChanged':
									break;
							}

							// see if there are any errors in the dom
							// eslint-disable-next-line no-undef
							tis.cardErrorsInDOM = $('.sq-input--error').length;
						},
						paymentFormLoaded: function() {
							// console.log("FORM LOADED")
							// eslint-disable-next-line no-undef
							$('.credit_card').addClass('loaded');
						},
					},
				});
				setTimeout(() => {
					if (document.getElementById('sq-card')) {
						this.paymentForm.build();
						this.digitalWalletForm.build();
					}

					if (typeof window.OnCheckoutViewed != 'undefined') {
						//console.log("window.OnCheckoutViewed()");
						window.OnCheckoutViewed(
							this.$store.getters.simpleOrder,
							this.customer
						);
					}
				}, 100);
			}, // launch_square_up
		},
		created() {
			document.body.style.backgroundColor = '#f8f8f8'; // cart page has different bg color

			// retrieve cached order information for retry
			if (localStorage.getItem('CData'))
				this.CData = JSON.parse(localStorage.getItem('CData'));
		},
		updated() {
			const event = new CustomEvent('si-updated');
			document.dispatchEvent(event);
			console.log('si-updated dispatched');
		},
		mounted() {
			const event = new CustomEvent('si-mounted');
			document.dispatchEvent(event);
			console.log('si-mounted dispatched');

			// Update the document title.
			document.title = 'Cart Summary';

			// Trigger AddToCart conversion in Sojern.
			//this.sojernAddProductsToCart(this.sojernProductsSnapshot);
			this.sojernAddProductsToCart();

			// `this.checkout` is passed as a prop from the router.js file
			if (this.checkout) {
				this.scrollToCheckout();
			} else {
				window.scrollTo(0, 0);
			}

			// make sure orderkey stored locally matches what is in the url
			var orderKey = this.$localStorage.get('orderKey');
			console.log('stored:', orderKey, 'route:', this.$route.params.orderKey);

			this.iframe = localStorage.getItem('iframeModal');
			console.log('iframeModal', this.iframe);
			if (orderKey != this.$route.params.orderKey && !this.iframe) {
				// if (orderKey != this.$route.params.orderKey) {
				console.log('Stored orderkey does not match, run away!');
				this.$router.push('/' + this.$route.params.client);
			}

			console.log('Cart Order', this.order);
		},
		destroyed() {
			document.body.style.backgroundColor = '#fff'; // change bg color when leaving cart page
		},
		beforeRouteEnter(to, from, next) {
			console.log(to, from);
			if (window.parent) {
				window.parent.postMessage({ cartnav: to.path }, '*');
			}
			next();
		},
		beforeRouteLeave(to, from, next) {
			let pathmatch = /\/\d*\/activity$/;
			if (pathmatch.test(to.path) && this.iframe) {
				history.back();
			}
			next();
		},
	};
</script>

<style lang="scss">
	$cart-width: 942px;
	// #cart-container {
	// 	visibility: visible;
	// }
	// desktop
	@media only screen and (min-width: 942px) {
	}

	// mobile
	@media only screen and (max-width: 942px) {
		html {
			::-webkit-scrollbar {
				// remove this for production
				display: none;
			}
		}
	}

	::placeholder {
		/* Chrome, Firefox, Opera, Safari 10.1+ */
		color: var(--border-color) !important;
		opacity: 1;
	}

	#secure-checkout {
		display: flex;
		align-items: center;
		margin: auto;
		width: 100%;
		color: #12c904;
		font-weight: 500;

		// desktop
		@media only screen and (min-width: $cart-width) {
			grid-area: 1/1/2/3;
			padding-top: var(--grid-gap);
		}

		// mobile
		@media only screen and (max-width: $cart-width) {
			grid-area: 2/1/3/2;
			padding-left: var(--outer-padding);
		}
	}

	.order-rows {
		display: grid;
		grid-gap: var(--inner-padding);
	}

	#cart-container {
		display: grid;
		margin: auto;
		grid-gap: var(--grid-gap);
		padding-bottom: 10vh;

		// desktop
		@media only screen and (min-width: 942px) {
			width: var(--cart-width);
			grid-template-columns: 560px 360px;
		}

		// mobile
		@media only screen and (max-width: 942px) {
			width: 100vw;
			grid-template-columns: 100vw;
			// display: none;
		}
	}

	#cart_items {
		background: #fff;
		box-shadow: 0px 1px 3px #00000029;
		display: grid;
		height: fit-content;
		grid-gap: 22px;
		// border: 1px solid var(--border-color);
		padding: var(--outer-padding) 0;
		border-radius: var(--card-border-radius);

		.cart-divider {
			height: 1px;
			background: var(--border-color);
		}

		.cart-row-item {
			position: relative;
			display: grid;
			grid-template-columns: 50px auto;
			grid-gap: 10px;
			padding: 0 var(--outer-padding);
			cursor: pointer;

			&:hover {
				& .pkg-title,
				.activity-name {
					color: var(--highlight);

					&::after {
						visibility: visible;
					}
				}
			}
		}

		// desktop
		@media only screen and (min-width: $cart-width) {
			grid-area: 2/2/3/3;

			// keep cart along side contact info while scrolling
			position: sticky;
			top: 79px;
		}

		// mobile
		@media only screen and (max-width: $cart-width) {
			grid-area: 1/1/2/2;
			border-radius: 0;
		}
	}

	#customer_items {
		// desktop
		@media only screen and (min-width: $cart-width) {
			grid-area: 2/1/3/2;
		}

		// mobile
		@media only screen and (max-width: $cart-width) {
			grid-area: 3/1/4/2;
		}
	}

	#payment_card {
		margin-top: 22px;
	}

	#order_headline {
		text-transform: uppercase;
		font-size: 13px;
		font-weight: 500;
		margin: 0;
		padding: 0 25px 0;
	}

	.wide-cart-btn {
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	#power-footer {
		position: absolute;
		top: calc(100% + 35px);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		font-size: 15px;
		user-select: none;
		color: #6a6a6a;

		&:hover {
			color: var(--highlight);
		}

		// mobile
		@media only screen and (max-width: $cart-width) {
			display: none;
		}
	}

	#power-footer-mobile {
		display: none;
		// mobile
		@media only screen and (max-width: $cart-width) {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			font-size: 15px;
			user-select: none;
			color: #6a6a6a;
			grid-area: 4/1/5/2;
		}
	}

	.cart-link {
		color: var(--highlight);
		cursor: pointer;
	}

	#discount-accordion {
		padding: 0 var(--outer-padding);
		height: fit-content;

		details {
		}

		details summary {
			position: relative;
			cursor: pointer;
			list-style: none;
			list-style-type: none;
			display: inline;
			width: 100%;
			outline: none !important;
			font-size: 15px;

			:focus {
				outline: none;
			}

			&::marker, // chrome, FF, Edge
    &::-webkit-details-marker {
				// safari
				display: none;
				content: '';
			}
		}

		summary::after {
			float: right;
			content: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'><polyline points='6 9 12 15 18 9'></polyline></svg>");
		}

		// details[open] {
		// }

		.details-content {
			padding-top: var(--inner-padding);
		}

		details[open] summary:after {
			content: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'><polyline points='18 15 12 9 6 15'></polyline></svg>");
		}

		input,
		button {
			font-size: 16px;
			height: 48px;
			margin-bottom: 0px;
		}

		.error {
			margin: 0;
			padding: 4px;
			font-size: 12px;
			margin-bottom: 5px;
		}

		.gift_promo {
			border: none;
			height: fit-content;
		}
	}

	.delete_button {
		position: absolute;
		right: var(--outer-padding);
		cursor: pointer;
		outline: none;
		border: none;
		background: none;
		width: 16px;
		height: 16px;

		&::before {
			content: url("data:image/svg+xml; utf8,<svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.2253 4.81108C5.83477 4.42056 5.20161 4.42056 4.81108 4.81108C4.42056 5.20161 4.42056 5.83477 4.81108 6.2253L10.5858 12L4.81114 17.7747C4.42062 18.1652 4.42062 18.7984 4.81114 19.1889C5.20167 19.5794 5.83483 19.5794 6.22535 19.1889L12 13.4142L17.7747 19.1889C18.1652 19.5794 18.7984 19.5794 19.1889 19.1889C19.5794 18.7984 19.5794 18.1652 19.1889 17.7747L13.4142 12L19.189 6.2253C19.5795 5.83477 19.5795 5.20161 19.189 4.81108C18.7985 4.42056 18.1653 4.42056 17.7748 4.81108L12 10.5858L6.2253 4.81108Z' fill='currentColor'/></svg>");
		}
	}

	.cart-links {
		padding: 0 var(--outer-padding);
		display: flex;
		justify-content: space-between;
	}

	.subtotal {
		float: right;
	}
</style>
